import Box from '@mui/material/Box'
import styled from '@mui/system/styled'

export const StyledBox = styled(Box)(({ minWidth }) => ({
  minWidth: minWidth ?? 120,
}))
